import { useTranslation } from "react-i18next"

import { CourseList } from "@/features/training/components/course-list"
import { DemoTranslatorTips } from "@/features/training/components/demo"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"
import { ensureArray } from "@/features/training/utils/ensure-array"

export function TranslatorTakeawaysPage() {
  const { t } = useTranslation("", { keyPrefix: "training.ai-translator.takeaways" })

  const keyPoints = ensureArray<string>(t("key_points", { returnObjects: true }))
  const tipsList = ensureArray<string>(t("tips_list", { returnObjects: true }))

  return (
    <CourseLayout>
      <h2>{t("main_title")}</h2>
      <CourseSection>
        <h3>{t("summary_title")}</h3>
        <p>{t("summary_text")}</p>
        <CourseList data={keyPoints} />
      </CourseSection>

      <CourseSection>
        <h3>{t("dos_and_donts_title")}</h3>
        <p>{t("dos_and_donts_intro")}</p>
        <div className="my-2">
          <DemoTranslatorTips />
        </div>
      </CourseSection>

      <CourseSection>
        <h3>{t("tips_title")}</h3>
        <CourseList data={tipsList} />
      </CourseSection>
    </CourseLayout>
  )
}
